import React from 'react';
import { useNavigate } from 'react-router-dom';
import StudentHeader from '@/components/student/StudentHeader';

import { Button } from '@/components/ui/button';
import { BookOpen, Award, PlayCircle } from 'lucide-react';

const StudentAssessments = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <StudentHeader />
      <div className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-slate-900 mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
          My Assessments
        </h1>
        
        <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
          <BookOpen className="h-16 w-16 text-blue-600 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-slate-900 mb-2">
            Online Assessment Portal
          </h2>
          <p className="text-slate-600 mb-6 max-w-md mx-auto">
            Browse available assessment courses, enroll in STT or RPL programs, 
            take online MCQ exams, and get instant certificates upon passing.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              className="bg-blue-600 hover:bg-blue-700"
              onClick={() => navigate('/assessment')}
              data-testid="go-to-assessment-portal"
            >
              <PlayCircle className="h-4 w-4 mr-2" />
              Go to Assessment Portal
            </Button>
          </div>
          
          <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div className="p-4 bg-blue-50 rounded-lg">
              <p className="font-semibold text-blue-700">13 Courses</p>
              <p className="text-blue-600">Available for assessment</p>
            </div>
            <div className="p-4 bg-emerald-50 rounded-lg">
              <p className="font-semibold text-emerald-700">45 Minutes</p>
              <p className="text-emerald-600">Per examination</p>
            </div>
            <div className="p-4 bg-purple-50 rounded-lg">
              <p className="font-semibold text-purple-700">50% Passing</p>
              <p className="text-purple-600">Score required</p>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default StudentAssessments;
